@if (!clearingEnabled) {
	<uc-clearing-courses-empty-state [subject]="subject()" />
} @else {
	<uc-clearing-course-search
		[subject]="subject()"
		[studyMode]="mode()"
		[location]="location()"
		[page]="page()"
		[ucaspts]="ucaspts()"
		[search]="search()"
		[degree]="degree()"
	/>
}
